import { ReactNode, useEffect, useMemo } from 'react';

import { api } from '@/api';
import { DEFAULT_KEY_IMAGE_PARAMS } from '@/shared/constant';
import { useStudyGuard } from '@/shared/guard';
import { useDefaultAndCommonFindings } from '@/shared/hook';
import { isNotEmpty } from '@/shared/util';
import { useKeyImageLabelsStore } from '@/store';

import { generateKeyImageLabelList } from './util';

interface KeyImageStateProps {
  children: ReactNode;
}

export function KeyImageState({ children }: KeyImageStateProps) {
  const { studyId } = useStudyGuard();

  const setKeyImageLabels = useKeyImageLabelsStore((state) => state.setKeyImageLabels);

  const { refetch } = api.hi.radiologist.query.useGetKeyImages(
    {
      payload: { params: DEFAULT_KEY_IMAGE_PARAMS, studyId },
    },
    { enabled: false, retry: false, staleTime: Infinity },
  );

  const defaultAndCommonFindings = useDefaultAndCommonFindings();

  const keyImageLabelList = useMemo(
    () => generateKeyImageLabelList(defaultAndCommonFindings),
    [defaultAndCommonFindings],
  );

  useEffect(() => {
    if (isNotEmpty(keyImageLabelList)) {
      setKeyImageLabels(keyImageLabelList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyImageLabelList]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return children;
}
